import SeatmapUIModel from './seatmap';

class SeatmapCollectionUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    _collection = [],
  }) {
    const seatMapsAvailables = _collection.filter(seatmap => {
      return !(seatmap && seatmap.segment && (seatmap.segment.arrivalAirport === 'TJX' || seatmap.segment.departureAirport === 'TJX'));
    });

    this._seatmapsBySegment = seatMapsAvailables.map(seatmap => {
      return new SeatmapUIModel(seatmap);
    });
  }

  /* Getters */

  /**
   * Gets array of available seats for leg - for tracking purposes
   * @param {Array} segmentCodesForLeg - list of segmentCodes for leg
   * @param  {Number} currentSegmentIndex - index of segment
   * @return {Array[SeatUIModel]}
   */
  getAvailableSeats(segmentCodesForLeg, currentSegmentIndex) {
    const seatmapUIModel = this.getSeatmapsByLeg(segmentCodesForLeg)[currentSegmentIndex];

    const availableSeats = [];

    seatmapUIModel.sections.forEach((section) => {
      section.rows.forEach((row) => {
        row.seats.forEach((seat) => {
          if ( seat.status === 'AVAILABLE' ) {
            availableSeats.push(seat);
          }
        });
      });
    });

    return availableSeats;
  }

  /**
   * @return {Boolean}
   */
  isAnySeatmapAvailable() {
    let isAnySeatmapAvailable = false;
    for (let i = 0; i < this._seatmapsBySegment.length; i++) {
      const seatmap = this._seatmapsBySegment[i];
      if (seatmap.isAvailable) {
        isAnySeatmapAvailable = true;
        break;
      }
    }
    return isAnySeatmapAvailable;
  }

  /**
   * @return {Number}
   */
  getNumberOfSeatmaps() {
    return this._seatmapsBySegment.length;
  }

  /**
   * @param  {Number} currentSegmentIndex - index of segment
   * @return {SeatmapUIModel}
   */
  getSeatmapForSegment(currentSegmentIndex) {
    return this._seatmapsBySegment[currentSegmentIndex];
  }

  /**
   * @param {Array} segmentCodesForLeg - list of segmentCodes for leg
   * @return {Array} list of seatmap ui models for leg
   */
  getSeatmapsByLeg(segmentCodesForLeg) {
    const seatmaps = [];

    this._seatmapsBySegment.forEach(seatmap => {
      if (segmentCodesForLeg.indexOf(seatmap.segment.segmentCode) > -1) {
        seatmaps.push(seatmap);
      }
    });
    return seatmaps;
  }

  /**
   * @return {Obj} seatmaps's prices by segment
  **/
  getPricesSeatMaps() {
    const seatmapPrices = {};
    this._seatmapsBySegment.forEach(seatmap => {
      seatmapPrices[seatmap.segment.segmentCode] = seatmap.getPricesSeatMap();
    });
    return seatmapPrices;
  }
}

export default SeatmapCollectionUIModel;
